import { useMutationHook, useQueryHook } from "@/hooks"
import {
  createSessionType,
  deleteSessionType,
  readSessionTypes,
  readTeamDeviceList,
  readTeamProfileInfo,
  upsertSessionType,
} from "@/app/api/team"
import { ApiError } from "@/app/api/type"
import { Team } from "@/types/team"
import { UseQueryOptions } from "@tanstack/react-query"

export const useTeamProfileInfoQuery = (idfTeams: number) => {
  return useQueryHook({
    queryKey: ["readTeamProfileInfo", idfTeams],
    queryFn: () => {
      return readTeamProfileInfo(idfTeams)
    },
    options: {
      enabled: !!idfTeams,
    } as UseQueryOptions<Team, ApiError>,
  })
}

export const useSessionTypeQuery = () => {
  return useQueryHook({
    queryKey: ["readSessionType"],
    queryFn: readSessionTypes,
  })
}

export const useCreateSessionTypeMutation = () => {
  return useMutationHook(createSessionType, ["readSessionType"])
}

export const useUpsertSessionTypeMutation = () => {
  return useMutationHook(upsertSessionType, ["readSessionType"])
}

export const useDeleteSessionTypeMutation = () => {
  return useMutationHook(deleteSessionType, ["readSessionType"])
}

export const useReadTeamDeviceListQuery = () => {
  return useQueryHook({
    queryKey: ["readTeamDeviceList"],
    queryFn: () => {
      return readTeamDeviceList()
    },
  })
}
